
<a :href="link">{{ text }}</a>
